// import { useParams } from "react-router-dom";
import { useGetTrackItems } from "../../../../hooks/api/queries";
import { getUrlQuerysection } from "../../../../helpers";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";
import { useSelector } from "react-redux";

const useTrackItem = () => {
  const queries = getUrlQuerysection();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { search, gotoPage, filterByStoreId, filterBySearch, filterByKey } =
    useUrlSearch();

  const { isLoading: isFetchingTrackItems, data } = useGetTrackItems({
    isEnabled: true,
    queries,
  });

  const filterByVariant = (variantId) => {
    filterByKey("variant_id", variantId);
  };

  const filterByStatus = (value) => {
    filterByKey("is_sold", value);
  };

  return {
    search,
    storeList,
    isFetchingTrackItems: isFetchingTrackItems,
    trackedItems: data?.data || [],
    metaDetails: data?.meta || {},
    // productDetails,
    filterByVariant,
    filterByStatus,
    filterByStore: filterByStoreId,
    gotoPage,
    searchTrackItem: filterBySearch,
  };
};
export default useTrackItem;
